import React, { Component } from 'react';
import FetchRSS from '../actions/fetchrss';

class Filter extends Component {
  constructor() {
    super();
    this.state = {
        filter: FetchRSS.getFilter()
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
  }

  handleChange(event) {
    let filter = this.state.filter;
    filter[event.target.id] = event.target.checked;
    this.setState({
        filter: filter
    })

    FetchRSS.saveFilter(filter);

    this.props.updateList();
  }

  render() {
    return (
      <div className="filter">
          <div>Show alerts for:</div>
          <div><input type="checkbox" onChange={this.handleChange} checked={this.state.filter.blueprints} id="blueprints" /> Blueprints</div>
          <div><input type="checkbox" onChange={this.handleChange} checked={this.state.filter.auras} id="auras" /> Auras</div>
          <div><input type="checkbox" onChange={this.handleChange} checked={this.state.filter.resources} id="resources" /> Resources</div>
          <div><input type="checkbox" onChange={this.handleChange} checked={this.state.filter.credits} id="credits" /> Credits</div>
          <div><input type="checkbox" onChange={this.handleChange} checked={this.state.filter.endo} id="endo" /> Endo</div>
      </div>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/filter.js